module.exports = __webpack_public_path__ + "static/img/direct_hit_movie_thum_02_no_btn.dc36bb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/movie/direct_hit_movie_thum_02_no_btn.jpg
// module id = uz+y
// module chunks = 0